
export const membershipTypes = [
  "Seed Grower",
  "Ware Grower",
  "Associate Member (Trade/Supply Chain)",
] as const;

export type MembershipType = typeof membershipTypes[number];

export interface AddressFields {
  street1: string;
  street2?: string;
  city: string;
  postalCode: string;
}

export interface PhoneFields {
  areaCode: string;
  number: string;
}

export interface MembershipFormData {
  applicationDate: Date;
  businessName: string;
  email: string;
  firstName: string;
  lastName: string;
  address: AddressFields;
  businessAddress: AddressFields;
  mobileNumber: PhoneFields;
  businessNumber: PhoneFields;
  membershipType: MembershipType;
  currentPotatoArea?: string;
  totalPotatoArea?: string;
  plannedPotatoArea?: string;
  termsAccepted: boolean;
  signature?: string;
  captchaToken: string;
}
